import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { enableMapSet } from 'immer';

import { isDev } from '~/dev/utils/isDev';
import { api } from '~/redux/api/createApi';
import { reducer } from '~/redux/slices';

enableMapSet();

export const middleware = (gdm) =>
  gdm({
    serializableCheck: false,
    immutableCheck: false,
  }).concat(api.middleware);

const store = configureStore({
  reducer,
  middleware,
  devTools: isDev,
});

setupListeners(store.dispatch);

export default store;
